import React, { useCallback, useMemo, useEffect } from 'react';
import { useQuery } from 'react-query';
import { Form, notification, Button as AntButton, Popconfirm } from 'antd';
import { PlusOutlined, CloseOutlined } from '@ant-design/icons';
import DataGrid from 'components/DataGrid';
import SaveButton from 'components/SaveButtonAction';
import { DataGridColDef } from 'components/DataGrid/DataGrid';
import { indexBy } from 'utils/utils2';
import { useFormList } from 'hooks/useFormList';

import ThirdPartyInput from 'components/ThirdPartyInput';
import ButtonOperation from 'components/ButtonOperation';
import {
  createBrokerParFiltering,
  getParFilteringByBroker,
  removeBrokerParFiltering,
} from 'services/parametersService';
import DeleteButton from 'components/DeleteButton';
import { MgUserJobAuthorizationResponse } from 'services/pricing';
import ModalControllerNV from 'components/ModalControllerNV';
import ThirdPartyModal from 'pages/ThirdParty/ThirdPartyDetail/ThirdPartyModal';

const BrokerThirdParty = ({ mgid, tpidbroker }: any) => {
  const NEW_BROKER_THIRDPARY_ID = -1;
  const [form] = Form.useForm();
  const fieldName = 'Authorization';

  const { add, remove } = useFormList(form, fieldName, {
    idKey: 'filterid',
    addAsFirst: true,
  });

  const { data, refetch, isFetching } = useQuery(
    [
      'getParValuesByBroker',
      {
        mgid: mgid,
        parcode: 'THIRDPARTY',
        tpidbroker: tpidbroker,
      },
    ],
    () =>
      getParFilteringByBroker({
        tpidbroker: tpidbroker,
      })
        .then((res) => res.list || [])
        .catch((res) => [])
  );

  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        [fieldName]: data.map((e) => ({ ...e, parvalue: Number(e.parvalue) })),
      });
    } else {
      form.setFieldsValue({
        [fieldName]: [],
      });
    }
      console.log('API Response:', data); // Log the fetched data

  }, [form, data]);

  const onSaveOrEdit = useCallback(
    (record: any) => {
      const auth: any[] = form.getFieldValue(fieldName);
      const index = indexBy(auth, 'filterid')[record.filterid];
      
      
      const currentValue = {
        ...auth[index],
      };

      console.log('currentValue:', currentValue); // Log the current value
      
      createBrokerParFiltering({
        request: {
          filterid: 0,
          flagdefault: false,
          mgid: mgid,
          parcode: 'THIRDPARTY',
          parvalue: currentValue?.parvalue,
          tpidbroker: tpidbroker,
        },
        tpidbroker: tpidbroker,
      }).then((res) => {
        refetch();
        if (res.code === '200') {
          notification.success({
            message: res.message,
          });
        }
      });
    },
    [form, refetch]
  );
  const getName = useCallback(
    (name: string) => (record: any) => {
      const functions = form.getFieldValue(fieldName);
      const index = indexBy(functions, 'filterid')[record.filterid];
      return [fieldName, index, name];
    },
    [form]
  );
  const columns = useMemo<DataGridColDef<MgUserJobAuthorizationResponse>[]>(
    () => [
      {
        dataIndex: 'filterid',
        width: 80,
      },

      {
        dataIndex: 'parcode',
        width: 80,
      },
      {
        dataIndex: 'parvalue',
        render: (value, record) => {
          console.log('record:', record); 
                 
          return  record?.filterid === NEW_BROKER_THIRDPARY_ID ? (
            <Form.Item noStyle shouldUpdate>
              {({ getFieldValue }) => (
                <Form.Item noStyle name={getName('parvalue')(record)}>
                  <ThirdPartyInput onlytpid EntityDataByid />
                </Form.Item>
              )}
            </Form.Item>
          ): (
                      <ModalControllerNV
                        modal={({ setVisible, visible }) => (
                          <ThirdPartyModal
                            tpId={record.tpidbroker}
                            visible={visible}
                            onCancel={() => setVisible(false)}
                            onSuccess={() => setVisible(false)}
                            title={         record.parvaluelabel}
                            iscreate={false}
                          />
                        )}
                        content={({ setVisible, visible }) => (
                          <a
                            onClick={() => {
                              setVisible(true);
                            }}
                          >
                            {record.parvaluelabel}
                          </a>
                        )}
                      />
                    );
        },
        width: 200,
      },

      {
        key: 'actions',
        render: (record) =>
          record.filterid === NEW_BROKER_THIRDPARY_ID ? (
            <>
              <SaveButton
                onClick={(ev) => {
                  onSaveOrEdit(record);
                }}
                comcode="save"
                htmlType="button"
              />
              <AntButton
                danger
                icon={
                  <CloseOutlined height="14px" width="14px" color="white" />
                }
                onClick={() => remove(record.filterid)}
              />
            </>
          ) : (
            <Popconfirm
              title="Sure to delete?"
              onConfirm={() => {
                removeBrokerParFiltering({
                  filterid: record?.filterid ?? 0,
                  tpidbroker: tpidbroker,
                }).then((res) => {
                  if (res.code === '200') {
                    refetch();
                    notification.success({
                      message: res.message,
                    });
                  }
                });
              }}
            >
              <DeleteButton onlyIcon />
            </Popconfirm>
          ),
        align: 'center',
        width: 150,
      },
    ],

    [
      getName,
      form,
      mgid,
      NEW_BROKER_THIRDPARY_ID,
      onSaveOrEdit,
      remove,
      refetch,
    ]
  );
  const row: any = {
    filterid: NEW_BROKER_THIRDPARY_ID,
    flagdefault: false,
    mgid: mgid,
    parcode: 'THIRDPARTY',
    parvalue: '' as any,
    tpidbroker: tpidbroker,
  };
  const addRow = () => {
    add(row);
  };

  return (
    <Form form={form} initialValues={row}>
      <Form.Item noStyle shouldUpdate>
        {({ getFieldValue }) => {
          const list: any[] = getFieldValue(fieldName);
        
          
          
          const isNewItemInTable =
            list?.find(
              ({ filterid }) => filterid === NEW_BROKER_THIRDPARY_ID
            ) !== undefined;
          return (
            <DataGrid
              rowKey="filterid"
              dataSource={list}
              titleComcode="Auth"
              columns={columns}
              isLoading={isFetching}
              hideFilters
              extraActions={
                <ButtonOperation
                  type="primary"
                  icon={<PlusOutlined />}
                  onClick={addRow}
                  disabled={isNewItemInTable}
                  comcode="add"
                />
              }
            />
          );
        }}
      </Form.Item>
    </Form>
  );
};

export default BrokerThirdParty;
